import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/** The label typography rung — 11px Instrument Sans 500, sentence case, no
 *  tracking, per design-grammar §2 (DECISIONS 2026-08-26 "Labels leave the
 *  terminal"). The name is historical: until 2026-08-26 this rung was uppercase
 *  JetBrains Mono, which read as a terminal on a family-facing product. Mono is
 *  now a data face only (IDs, times, amounts, code-entry inputs).
 *  Exported so `StatusChip` renders identical type without restating it; two
 *  copies of a type recipe drift, and a chip whose label is a different size
 *  from the labels beside it is the drift you notice last.
 *  Rename to `Label`/`Eyebrow` is owed under #1191. */
export const MONO_LABEL_TYPE = 'font-label text-label font-medium';

interface MonoLabelProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'muted' | 'indigo' | 'ink';
}

const TONE_CLASS: Record<NonNullable<MonoLabelProps['tone']>, string> = {
  muted: 'text-stevens-ink-3',
  indigo: 'text-stevens-indigo',
  ink: 'text-stevens-ink',
};

export function MonoLabel({ className, tone = 'muted', children, ...rest }: MonoLabelProps) {
  return (
    <span
      className={cn(MONO_LABEL_TYPE, TONE_CLASS[tone], className)}
      {...rest}
    >
      {children}
    </span>
  );
}
